import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['link'];

  updateLink(event) {
    const email = event.target.value;
    const baseHref = this.linkTarget.dataset.baseHref;

    if (email) {
      this.linkTarget.href = `${baseHref}?email=${encodeURIComponent(email)}`;
    } else {
      this.linkTarget.href = baseHref;
    }
  }
}
